import FiscalControl from '../../../public/Images/Quick Links/FiscalControl.png';
import InsightsBoard from '../../../public/Images/Quick Links/InsightsBoard.png';
import TaskBoard from '../../../public/Images/Quick Links/TaskBoard.png';
import DataSphere from '../../../public/Images/Quick Links/DataSphere.png';

import PlanDocument from '../../../public/Images/Quick Links/PlanDocument.png';
import Contracts from '../../../public/Images/Quick Links/Contracts.png';
import ComplianceReports from '../../../public/Images/Quick Links/Compliance Report.png';
import DraftAnalyzer from '../../../public/Images/Quick Links/DraftAnalyzer.png';
import DueDeligence from '../../../public/Images/Quick Links/DueDeligence.png';
import DocumentComparison from '../../../public/Images/Quick Links/DocumentComparison.png';
import TermCompiler from '../../../public/Images/Quick Links/TermCompiler.png';
import AnnualRenewalProcess from '../../../public/Images/Quick Links/AnnualRenewalProcess.png';
import PlaybookAndStandard from '../../../public/Images/Quick Links/PlaybookAndStandard.png';

import DiseaseManagement from '../../../public/Images/Quick Links/DiseaseManagement.png';
import CostManagement from '../../../public/Images/Quick Links/CostManagement.png';
import StopLossMangement from '../../../public/Images/Quick Links/StopLossMangement.png';
import PlanUtilization from '../../../public/Images/Quick Links/PlanUtilization.png';
import ClaimsManagement from '../../../public/Images/Quick Links/ClaimsManagement.png';
import MedicalUtilization from '../../../public/Images/Quick Links/MedicalUtilization.png';
import DrugUtilization from '../../../public/Images/Quick Links/DrugUtilization.png';
import RiskProfile from '../../../public/Images/Quick Links/RiskProfile.png';
import DeepDive from '../../../public/Images/Quick Links/DeepDive.png';
import TrendAnalysis from '../../../public/Images/Quick Links/TrendAnalysis.png';
import CohortComparison from '../../../public/Images/Quick Links/CohortComparison.png';
import ClaimList from '../../../public/Images/Quick Links/ClaimList.png';
import MemberList from '../../../public/Images/Quick Links/MemberList.png';
import Reports from '../../../public/Images/Quick Links/Reports.png';
import ClaimsAnalytics from '../../../public/Images/Quick Links/ClaimsAnalytics.png';
import PaymentIntegrity from '../../../public/Images/Quick Links/PaymentIntegrity.png';
import CMSBenchmarking from '../../../public/Images/Quick Links/CMSBenchmarking.png';
import ProposalAnalyzer from '../../../public/Images/Quick Links/proposal_analyzer.png';

import {
  CLAIMS_LIST,
  ACCESS_DASHBOARD,
  COMPLIANCE_REPORT,
  CONTRACT_AIQ,
  DATA_CATALOGUE,
  DEEP_DIVE,
  DOC_COMPARISON,
  DRAFT_AGREEMENTS,
  MA_DUE_DILIGENCE,
  MEMBER_LIST,
  PLAN_DOCUMENTS,
  REPORTS,
  RISK_REGISTER,
  TASK_BOARD,
  TERM_COMPILER,
  // TREND_ANALYSIS,
  ANNUAL_RENEWAL_PROCESS,
  PLAYBOOK_AND_STANDARD,
  PAYMENT_INTEGRITY,
  CMS_BENCHMARK,
  COHORT_COMPARISON,
  // TREND_ANALYSIS_INTERNAL,
  PROPOSAL_ANALYZER,
  TREND_ANALYSIS,
} from '../routes';

export const messages = {
  CHIP_LABELS: {
    HIGH_RISK: 'High Risk',
    LOW_RISK: 'Low Risk',
  },
  CARD: {
    SHOW_ALL_GROUP: 'Show All Groups',
    GROUP_LABELS: ['Enrolled', 'PMPM', 'Total Cost'],
    CUSTOM_DASHBOARD_LABELS: ['Selected Cohorts', 'Download Frequency'],
    CONTRACT_LABELS: ['TPA', 'PBM', 'Stop Loss Carrier', 'Network'],
    SUBTITLE: 'For the plan period of ',
    SUBTITLE_MIDDLE_STRING: ' - ',
  },
  PAGE: {
    TITLE: 'Welcome to Homa AIQ',
    SUBTITLE: 'Click on a group to view insights from their data',
  },
  CUSTOM_TABLE_COMPONENT: {
    CREATE_NEW: 'Create New',
    DOWNLOAD_SELECTED: 'Download selected',
    DELETE_SELECTED: 'Delete selected',
  },
  TABLE_SORT_PROPS: ['High to Low', 'Low to High'],
  TABLE_ALPHABET_SORT: ['Z-A', 'A-Z'],
  IN_PROGRESS: 'In Progress',
  QUICK_LINKS: [
    {
      title: 'Plan Management',
      links: [
        {
          TITLE: 'Fiscal Control',
          IMAGE_E: FiscalControl,
          IMAGE_D: '',
          DISABLED: false,
          LINK: `/dashboard/${encodeURIComponent('Fiscal Controls')}`,
          DIRECTLINK: false,
          SCREEN_NAME: 'FISCAL_CONTROL',
        },
        {
          TITLE: 'Strategy & Insights Board',
          IMAGE_E: InsightsBoard,
          IMAGE_D: '',
          DISABLED: false,
          LINK: RISK_REGISTER,
          DIRECTLINK: false,
          SCREEN_NAME: 'RISK_REGISTER',
        },
        {
          TITLE: 'Task Board',
          IMAGE_E: TaskBoard,
          IMAGE_D: '',
          DISABLED: false,
          LINK: TASK_BOARD,
          DIRECTLINK: false,
          SCREEN_NAME: 'TASK_BOARD',
        },
        {
          TITLE: 'Data Sphere',
          IMAGE_E: DataSphere,
          IMAGE_D: '',
          DISABLED: false,
          LINK: DATA_CATALOGUE,
          DIRECTLINK: false,
          SCREEN_NAME: 'DATA_SPHERE',
        },
      ],
    },
    {
      title: 'Contract AIQ',
      links: [
        {
          TITLE: 'Plan Documents',
          IMAGE_E: PlanDocument,
          IMAGE_D: '',
          DISABLED: false,
          LINK: PLAN_DOCUMENTS,
          DIRECTLINK: false,
          SCREEN_NAME: 'PLAN_ANALYSIS',
        },
        {
          TITLE: 'Contracts',
          IMAGE_E: Contracts,
          IMAGE_D: '',
          DISABLED: false,
          LINK: CONTRACT_AIQ,
          DIRECTLINK: false,
          SCREEN_NAME: 'CONTRACT_ANALYSIS',
        },
        {
          TITLE: 'Compliance PDF Builder',
          IMAGE_E: ComplianceReports,
          IMAGE_D: '',
          DISABLED: false,
          LINK: COMPLIANCE_REPORT,
          DIRECTLINK: false,
          SCREEN_NAME: 'CONTRACT_ANALYSIS',
        },
        {
          TITLE: 'Draft Agreement Analyzer',
          IMAGE_E: DraftAnalyzer,
          IMAGE_D: '',
          DISABLED: false,
          LINK: DRAFT_AGREEMENTS,
          DIRECTLINK: false,
          SCREEN_NAME: 'DRAFT_ANALYZER',
        },
        {
          TITLE: 'M&A Due Diligence',
          IMAGE_E: DueDeligence,
          IMAGE_D: '',
          DISABLED: false,
          LINK: MA_DUE_DILIGENCE,
          DIRECTLINK: false,
          SCREEN_NAME: 'DUE_DILIGENCE',
        },
        {
          TITLE: 'Document Comparison',
          IMAGE_E: DocumentComparison,
          IMAGE_D: '',
          DISABLED: false,
          LINK: DOC_COMPARISON,
          DIRECTLINK: true,
          SCREEN_NAME: 'DOC_COMPARISON',
        },
        {
          TITLE: 'Term Compiler',
          IMAGE_E: TermCompiler,
          IMAGE_D: '',
          DISABLED: false,
          LINK: TERM_COMPILER,
          DIRECTLINK: true,
          SCREEN_NAME: 'TERM_COMPILER',
        },
        {
          TITLE: 'Annual Renewal Process',
          IMAGE_E: AnnualRenewalProcess,
          IMAGE_D: '',
          DISABLED: false,
          LINK: ANNUAL_RENEWAL_PROCESS,
          DIRECTLINK: true,
          SCREEN_NAME: 'ANNUAL_RENEWAL_PROCESS',
        },
        {
          TITLE: 'Playbook And Standard',
          IMAGE_E: PlaybookAndStandard,
          IMAGE_D: '',
          DISABLED: false,
          LINK: PLAYBOOK_AND_STANDARD,
          DIRECTLINK: true,
          SCREEN_NAME: 'PLAYBOOK_AND_STANDARD',
        },
        {
          TITLE: 'Proposal Analyzer',
          IMAGE_E: ProposalAnalyzer,
          IMAGE_D: '',
          DISABLED: false,
          LINK: PROPOSAL_ANALYZER,
          DIRECTLINK: false,
          SCREEN_NAME: 'PROPOSAL_ANALYZER',
        },
      ],
    },
    {
      title: 'Claims AIQ',
      links: [
        {
          TITLE: 'Disease Management',
          IMAGE_E: DiseaseManagement,
          IMAGE_D: '',
          DISABLED: false,
          LINK: `/dashboard/${encodeURIComponent('Disease Management')}`,
          DIRECTLINK: false,
          SCREEN_NAME: 'DISEASE_MANAGEMENT',
        },
        {
          TITLE: 'Cost Management',
          IMAGE_E: CostManagement,
          IMAGE_D: '',
          DISABLED: false,
          LINK: `/dashboard/${encodeURIComponent('Cost Management')}`,
          DIRECTLINK: false,
          SCREEN_NAME: 'COST_MANAGEMENT',
        },
        {
          TITLE: 'Stop Loss Management',
          IMAGE_E: StopLossMangement,
          IMAGE_D: '',
          DISABLED: false,
          LINK: `/dashboard/${encodeURIComponent('Stop Loss Management')}`,
          DIRECTLINK: false,
          SCREEN_NAME: 'STOP_LOSS_MANAGEMENT',
        },
        {
          TITLE: 'Plan Analysis',
          IMAGE_E: PlanUtilization,
          IMAGE_D: '',
          DISABLED: false,
          LINK: `/dashboard/${encodeURIComponent('Plan Analysis')}`,
          DIRECTLINK: false,
          SCREEN_NAME: 'PLAN_ANALYSIS',
        },
        {
          TITLE: 'Claims Management',
          IMAGE_E: ClaimsManagement,
          IMAGE_D: '',
          DISABLED: false,
          LINK: `/dashboard/${encodeURIComponent('Claims Management')}`,
          DIRECTLINK: false,
          SCREEN_NAME: 'CLAIMS_MANAGEMENT',
        },
        {
          TITLE: 'Medical Claim Utilization',
          IMAGE_E: MedicalUtilization,
          IMAGE_D: '',
          DISABLED: false,
          LINK: `/dashboard/${encodeURIComponent('Medical Claim Utilization')}`,
          DIRECTLINK: false,
          SCREEN_NAME: 'MEDICAL_CLAIM_UTILIZATION',
        },
        {
          TITLE: 'Drug Utilization',
          IMAGE_E: DrugUtilization,
          IMAGE_D: '',
          DISABLED: false,
          LINK: `/dashboard/${encodeURIComponent('Drug Utilization')}`,
          DIRECTLINK: false,
          SCREEN_NAME: 'DRUG_UTILIZATION',
        },
        {
          TITLE: 'Risk Profile',
          IMAGE_E: RiskProfile,
          IMAGE_D: '',
          DISABLED: false,
          LINK: `/dashboard/${encodeURIComponent('Risk Profile')}`,
          DIRECTLINK: false,
          SCREEN_NAME: 'RISK_PROFILE',
        },
        {
          TITLE: 'Deep Dive',
          IMAGE_E: DeepDive,
          IMAGE_D: '',
          DISABLED: false,
          LINK: DEEP_DIVE,
          DIRECTLINK: false,
          SCREEN_NAME: 'DEEP_DIVE',
        },
        {
          TITLE: 'Trend Analysis',
          IMAGE_E: TrendAnalysis,
          IMAGE_D: '',
          DISABLED: false,
          LINK: TREND_ANALYSIS,
          DIRECTLINK: false,
          SCREEN_NAME: 'TREND_ANALYSIS',
        },
        {
          TITLE: 'Cohort Comparison',
          IMAGE_E: CohortComparison,
          IMAGE_D: '',
          DISABLED: false,
          LINK: COHORT_COMPARISON,
          DIRECTLINK: false,
          SCREEN_NAME: 'COHORT_COMPARISON',
        },
        {
          TITLE: 'Claims List',
          IMAGE_E: ClaimList,
          IMAGE_D: '',
          DISABLED: false,
          LINK: CLAIMS_LIST,
          DIRECTLINK: false,
          SCREEN_NAME: 'CLAIM_ANALYSIS',
        },
        {
          TITLE: 'Members List',
          IMAGE_E: MemberList,
          IMAGE_D: '',
          DISABLED: false,
          LINK: MEMBER_LIST,
          DIRECTLINK: false,
          SCREEN_NAME: 'MEMBER_IDENTIFICATION',
        },
        {
          TITLE: 'Claims Analytics PDF Builder',
          IMAGE_E: Reports,
          IMAGE_D: '',
          DISABLED: false,
          LINK: REPORTS,
          DIRECTLINK: false,
          SCREEN_NAME: 'REPORTS',
        },
        {
          TITLE: 'Claims Analytics Suite',
          IMAGE_E: ClaimsAnalytics,
          IMAGE_D: '',
          DISABLED: false,
          LINK: ACCESS_DASHBOARD,
          DIRECTLINK: false,
          SCREEN_NAME: 'EXPERIENCE',
        },
        {
          TITLE: 'Payment Integrity',
          IMAGE_E: PaymentIntegrity,
          IMAGE_D: '',
          DISABLED: false,
          LINK: PAYMENT_INTEGRITY,
          DIRECTLINK: false,
          SCREEN_NAME: 'PAYMENT_INTEGRITY',
        },
        {
          TITLE: 'CMS Benchmarking',
          IMAGE_E: CMSBenchmarking,
          IMAGE_D: '',
          DISABLED: false,
          LINK: CMS_BENCHMARK,
          DIRECTLINK: false,
          SCREEN_NAME: 'CMS_BENCHMARK',
        },
      ],
    },
  ],
  HIDDEN_QUICK_LINKS: [
    'Disease Management',
    'Cost Management',
    'Stop Loss Management',
    'Plan Analysis',
    'Claims Management',
    'Medical Claim Utilization',
    'Drug Utilization',
    'Risk Profile',
    'Claims List',
    'Members List',
  ],
};
